import {GET_MESSAGES, SELECT_ALL_MESSAGES, UNSELECT_ALL_MESSAGES} from "redux/types";

const INITIAL_STATE = {
    messages: [], selected: [], meta: {}
}

export const messagesReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_MESSAGES:
            return {
                ...state,
                messages: action?.payload?.rows,
                meta: action?.payload?.meta
            }
        case SELECT_ALL_MESSAGES:
            return {
                ...state,
                selected: action.payload
            }
        case UNSELECT_ALL_MESSAGES:
            return {
                ...state,
                selected: action.payload
            }
        default:
            return state;
    }
};